// src/pages/Shop.js

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/shopcatalog.css";

function Shop() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Të Gjitha"); // Initial selected category

  useEffect(() => {
    async function loadProducts() {
      try {
        const response = await fetch(
          "https://d3ejxze7429gw1.cloudfront.net/products"
        );
        const data = await response.json();

        // ❌ Filter OUT products with category "Sanittary Ware"
        const filtered = data.filter(
          (product) => product.category !== "Sanittary Ware"
        );

        setProducts(filtered);

        // Extract unique categories from remaining products
        const uniqueCategories = [
          "Të Gjitha",
          ...new Set(filtered.map((product) => product.category)),
        ];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error("Error loading products:", error);
      }
    }

    loadProducts();
  }, []);
  // Filter products based on selected category
  const filteredProducts =
    selectedCategory === "Të Gjitha"
      ? products
      : products.filter((product) => product.category === selectedCategory);

  return (
    <div className="shop-page-new">
      {/* Hero Section */}
      <div className="shop-hero-new">
        <div className="hero-content-new">
          <h1>Produktet tona Ekskluzive</h1>
          <p>
            Shfletoni nëpër zgjedhjen tonë premium të produkteve të kuruara
            vetëm për ju.
          </p>
          <div className="hero-buttons-new">
            {/* Scroll to Product Grid */}
            <button
              className="scroll-to-products-btn"
              onClick={() => {
                const section = document.getElementById("category-all");
                if (section) section.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Shiko Produktet
            </button>

            {/* Navigate to Sanitary Page */}
            <Link to="/sanitary-shop" className="go-to-sanitary-btn">
              Vetëm Sanitarë
            </Link>
          </div>
        </div>
      </div>

      {/* Category Filters */}
      <div className="category-filters-new" id="category-all">
        <h2>Zgjidhni Kategorinë Tuaj</h2>
        <div className="category-buttons-new">
          {categories.map((category) => (
            <button
              key={category}
              className={`category-button-new ${
                selectedCategory === category ? "active" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Product Grid */}
      <div className="product-grid-new">
        {filteredProducts.map((product) => (
          <div key={product.id} className="product-card-new">
            <img
              src={`https://d3ejxze7429gw1.cloudfront.net${product.imageUrl}`}
              alt={product.title}
            />
            <div className="product-details-new">
              <h3>{product.title}</h3>
              <Link to={`/shop/${product.id}`} className="view-product-btn-new">
                Shiko Detajet
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Shop;
